import React from "react";
import { Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from 'react-number-format';
import { DivideTitleComponent } from "../../components";

export default function CountCardComponent({ data, formState }) {

	const navigate = useNavigate();


	const handleCardClick = (key, title) => {
		formState.key = key;
		formState.title = title;
		navigate(`/dashboard-count-list`, { state: formState });

	};
	const floats = [
		{
			key: "total_children_rescued",
			title: "Total Children Rescued of Any Age",
			digit: data?.total_children_rescued,
			icon: "child_care",
			variant: "lg blue",
		},
		// {

		// 	key: "total_slave_born",

		// 	title: "Total Born Slave Rescued",
		// 	digit: data?.total_slave_born,
		// 	icon: "price_check",
		// 	variant: "lg red",
		// },
		// {
		// 	key: "teenage_count",

		// 	title: "Teenage Children (13-19 age)",
		// 	digit: data?.teenage_count,
		// 	icon: "price_check",
		// 	variant: "lg blue",
		// },
		// {
		// 	key: "youth_count",

		// 	title: "Youth Rescued (19-25 age)",
		// 	digit: data?.youth_count,
		// 	icon: "price_check",
		// 	variant: "lg blue",
		// },
		// {
		// 	key: "total_adult_rescued",
		// 	title: "Young Adult Rescued (25 & above age)",
		// 	digit: data?.total_adult_rescued,
		// 	icon: "settings_accessibility",
		// 	variant: "lg green",
		// },

		{
			key: "total_abused_families",

			title: "Total Abused Families",

			digit: data?.total_abused_families,
			icon: "settings_accessibility",
			variant: "lg blue",
		},
		{
			key: "total_slavery_years",
			title: "Total Years of Bonded Labor",
			noclick: true,
			digit: data?.total_slavery_years,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_families_rescued",
			noclick: true,
			title: "Average Family Size",
			digit:
				data?.total_families_rescued > 0
					? Math.round(
						data?.total_slaves / data?.total_families_rescued
					)
					: 0,
			icon: "price_check",
			variant: "lg blue",
		},

		{//here key is not set yet
			key: "total_families_rescued",
			title: "Average Years of Bonded Labor",
			noclick: true,
			digit:
				data?.total_families_rescued > 0
					? Math.round(
						data?.total_slavery_years /
						data?.total_families_rescued
					)
					: 0,
			icon: "price_check",
			variant: "lg blue",
		},
		{
			key: "total_baptized",
			title: "Total Number of Baptisms",

			digit: data?.total_baptized,
			icon: "water",
			variant: "lg blue",
		},
		{
			key: "total_spirtual_records",
			title: "Families Engaged with Churcht",
			noclick: true,
			digit: data?.spirtual_records,
			icon: "temple_buddhist",
			variant: "lg blue",
		},
		{
			key: "total_business_granted",
			title: "Total Business Started and Launched",

			digit: data?.total_business_granted,
			icon: "business_center",
			variant: "lg blue",

		},
		{
			divider: true,
			title: "CHILDREN & SCHOOL ATTENDANCE"
		},

		{
			key: "eligible_for_school",
			title: "Total number of children eligible for school",

			digit: data?.eligible_for_school,
			icon: "directions_bus",
			variant: "lg blue",
		},
		{
			key: "school_going_children",
			title: "Number of children attending school ",
			percent: data?.school_going_children / data?.eligible_for_school * 100,

			digit: data?.school_going_children,
			icon: "directions_bus",
			variant: "lg blue",
		},
		{
			key: "eligible_but_not_school_going",
			title: "Number of children not attending school",
			percent: data?.eligible_but_not_school_going / data?.eligible_for_school * 100,
			digit: data?.eligible_but_not_school_going,
			icon: "no_transfer",
			variant: "lg blue",
		},
		{
			divider: true,
			title: "Children in Accelerated Learning"
		},
		{
			key: "eligible_for_accelerated",
			title: "Eligible Children for Accelerated Learning",

			digit: data?.eligible_for_accelerated,
			icon: "lightbulb",
			variant: "lg blue",
		},
		{
			key: "children_in_accelerated_learning",
			title: "Number of Children in Classes",
			noclick: true,
			digit: data?.children_in_accelerated_learning,
			icon: "video_label",
			variant: "lg blue",
		},
		{
			key: "children_notin_accelerated_learning",
			title: "Number of Children not in Classes",
			noclick: true,
			digit: data?.children_notin_accelerated_learning,
			icon: "explore_off",
			variant: "lg blue",
		},

		{
			divider: true,
			title: "VOCATIONAL TRAINING"
		},
		{
			key: "total_evoc_trainings",
			title: "Total children eligible for vocational training",
			digit: data?.total_evoc_trainings,

			icon: "model_training",
			variant: "lg blue",
		},
		{
			key: "total_voc_trainings",
			title: "Total children attending vocational training",
			digit: data?.total_voc_trainings,
			percent: data?.total_voc_trainings / data?.total_evoc_trainings * 100,
			icon: "model_training",
			variant: "lg blue",
		},
		{
			key: "total_nvoc_trainings",
			title: "children not attending vocational training",
			digit: data?.total_evoc_trainings - data?.total_voc_trainings,
			percent: data?.total_evoc_trainings > 0
				? ((data.total_evoc_trainings - data.total_voc_trainings)
					/ data.total_evoc_trainings) * 100
				: 0,
			icon: "model_training",
			noclick: true,
			variant: "lg blue",
		},


		{
			divider: true,
			title: "Follow-Up Details"
		},
		{
			key: "total_el_followups",

			title: "Total families available for follow up ",
			digit: data?.total_el_followups,
			icon: "emoji_flag",
			variant: "lg blue",
		},
		{
			key: "total_family_followups",
			title: "Total number of families followed up",

			digit: data?.total_family_followups,
			percent: data?.total_family_followups / data?.total_el_followups * 100,
			icon: "outlined_flag",
			variant: "lg blue",
		},
		{
			key: "total_not_followups",
			title: "Total number of families NOT followed up",
			percent:
				data?.total_el_followups > 0
					? ((data?.total_el_followups - data?.total_family_followups)
						/ data?.total_el_followups) * 100
					: 0,
			digit: data?.total_not_followups,
			icon: "do_not_disturb",
			variant: "lg blue",
		},



		// {
		// 	key: "total_school_trainings",
		// 	title: "School Enrollments",
		// 	percent: data?.total_school_trainings / data?.eligible_but_not_school_going * 100,

		// 	digit: data?.total_school_trainings,
		// 	icon: "school",
		// 	variant: "lg blue",
		// },

		{
			divider: true,
			title: "Medical Records"
		},
		{
			key: "total_medical_records",
			title: "Medical Records",
			// percent: data?.total_school_trainings,
			noclick: true,
			digit: data?.medical_records,
			icon: "medical_information",
			variant: "lg blue",
		},

		// {
		// 	key: "total_families_rescued",
		// 	title: "Budget Expenditure",

		// 	digit: data?.total_budget_expenditure,
		// 	icon: "monetization_on",
		// 	variant: "lg blue",
		// },
		// {// here key is not set yet
		// 	noclick: true,
		// 	key: "Average-Debt-Per-Family",
		// 	title: "Average Debt Per Family",

		// 	digit: data?.total_loan_paid > 0
		// 		? Math.round(
		// 			data?.total_loan_paid / data?.total_families_rescued
		// 		)
		// 		: 0,
		// 	icon: "monetization_on",
		// 	variant: "lg blue",
		// },
	];
	return (
		<>
			{floats.map((data, index) => {

				if (data.divider === true) {
					return (
						<Col
							lg={12}
							key={index}>
							<DivideTitleComponent
								title={data.title}
								className="mb-4 mt-3"
							/>
						</Col>
					)
				}
				return (


					<Col
						key={index}
						sm={6}
						lg={4}
					>
						<div

							onClick={data.noclick ? null : () => handleCardClick(data.key, data.title)
							}
							className={`mc-float-card ${data.variant}`
							}
							style={{
								background:
									"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
								cursor: data.noclick ? "default" : "pointer",
							}}
						>
							<h3>	<NumericFormat
								value={data.digit}
								displayType="text"
								thousandSeparator
								className="card-number"
							/>
								<span className="dollar">{data.percent ? Math.round(data.percent) + '%' : ''}</span></h3>
							<p>{data.title}</p>
							<i
								className="material-icons"
								style={{ color: "#077834" }}
							>
								{data.icon}
							</i>
						</div >
					</Col >

				);
			})}
		</>
	);
}
